import type {
  CreateQuestionFormDTO,
  CreateQuestionFormTemplateDTO,
  QuestionDTO,
} from "@boostbiz/testing_form_microservice/client/schemas";
import {
  QuestionFormStatuses,
  QuestionType,
} from "@boostbiz/testing_form_microservice/client/consts";
import dayjs from "dayjs";
import { nanoid } from "nanoid";

export const getDefaultTestQuestion = (): QuestionDTO => {
  return {
    text: "",
    id: nanoid(),
    answers: [""],
    correctAnswers: [],
    files: [],
    filesInfo: [],
    answerType: QuestionType.variant,
    allowMultipleAnswers: false,
  };
};

export const getDefaultsTestData = (): CreateQuestionFormDTO => {
  return {
    projectId: '',
    articleId: '',
    showResults: false,
    name: "",
    inspectorId: "",
    passCondition: {
      countAnswers: 0,
      points: {
        maxPoint: 0,
        necessaryPoint: 0,
      },
      disable: false,
    },
    timer: {
      allow: true,
      minutes: 0,
      seconds: 0,
    },
    attempts: 1,
    formStatus: QuestionFormStatuses.draft,
    deadline: {
      allow: true,
      value: dayjs().add(1, "day").unix(),
    },
    reward: {
      allow: true,
      prizeAmount: 0,
      robbedAmount: 0,
      takeMoney: false,
    },
    responders: {
      all: false,
      positions: [],
      employees: [],
      divisions: [],
      departments: [],
    },
    categories: {
      value: "",
      items: [],
    },
    public: true,
    questions: [getDefaultTestQuestion()],
  };
};

export const getDefaultsTestTemplateData =
  (): CreateQuestionFormTemplateDTO => {
    return {
      templateSettings: {
        articleId: "",
        price: 0,
        placeholders: {
          inspectorId: "",
          responders: {
            all: false,
            positions: [],
            employees: [],
            divisions: [],
            departments: [],
          },
        },
        isActive: true,
      },
      showResults: false,
      name: "",
      passCondition: {
        countAnswers: 0,
        points: {
          maxPoint: 0,
          necessaryPoint: 0,
        },
        disable: false,
      },
      timer: {
        allow: true,
        minutes: 0,
        seconds: 0,
      },
      attempts: 1,
      formStatus: QuestionFormStatuses.draft,
      deadline: {
        allow: true,
        value: dayjs().add(1, "day").unix(),
      },
      reward: {
        allow: true,
        prizeAmount: 0,
        robbedAmount: 0,
        takeMoney: false,
      },
      categories: {
        value: "",
        items: [],
      },
      public: true,
      questions: [getDefaultTestQuestion()],
    };
  };
